import React, { useEffect, useRef, useState } from "react";
import DataTable from "react-data-table-component";
import "../css/estudiantes.css";
import {
    MDBBtn,
    MDBModal,
    MDBModalDialog,
    MDBModalContent,
    MDBModalHeader,
    MDBModalTitle,
    MDBModalBody,
    MDBModalFooter,
} from 'mdb-react-ui-kit';
import utils from '../utils/generalFunctions';
import { toast } from 'react-toastify';
import Swal from "sweetalert2";
import JornadaAnioPeriodoNivelCursoAsig from "../components/Filters/JornadaAnioPeriodoNivelCursoAsig";
import JornadaAnioPeriodoCursosAsigMulti from "../components/Filters/JornadaAnioPeriodoCursosAsigMulti";
import courseService from "../services/courseService";
import { Button } from "react-bootstrap";
import Loading from "../components/Loading";
import procesoService from "../services/procesoService";
import useCustomDataTableStyles from "../components/estilosDeDataTable";
import types from "../services/types";

const ProcesosPreventivosView = () => {

    ////Start
    const [filters, setFilters] = useState({ // Estado para los filtros aplicados
        teacherId: '0',
        journeyId: '0',
        schoolYearId: '0',
        educationLevelId: '0',
        courseId: '0'
    });
    const [paramProcesos, setParamProcesos] = useState({}); 
    const filteReference = useRef(null);
    const [showLoading, setShowLoading] = useState(false);
    const [procesos, setProcesos] = useState([]);
    const [showSearch, setShowSearch] = useState(false);

    // Selección de procesos para clonar
    const [selectedRows, setSelectedRows] = useState([]);
    const [toggledClearRows, setToggledClearRows] = useState(false);
    const [cloneModal, setCloneModal] = useState(false);
    const [cloneFilters, setCloneFilters] = useState({
        journeyId: '0',
        schoolYearId: '0',
        courseIds: [],
        schoolSubjectIds: [],
        periodId: '0',
    });
    const [cloneLoading, setCloneLoading] = useState(false);
    const cloneFilterReference = useRef(null);

    // La clonación de procesos preventivos solo la pueden usar administradores
    // y coordinadores, no docentes.
    const [userTypeId, setUserTypeId] = useState(null);
    const canCloneProcesos = userTypeId === types.userTypes.ADMIN || userTypeId === types.userTypes.COODINATOR;

    useEffect(() => {
        const user = utils.getUserInformation();
        if (user) {
            setUserTypeId(Number(user.userTypeId));
        }
    }, []);

    const customStyles = useCustomDataTableStyles();

    
    const handleFilterChange = (newFilters) => {
        // Actualiza el estado de filters con los nuevos valores
        setFilters(prev => ({
            ...prev,
            ...newFilters
        }));
    };

    // Limpia la selección de checkboxes de la tabla (cambia al buscar de nuevo,
    // eliminar un proceso o tras clonar).
    const clearRowSelection = () => {
        setSelectedRows([]);
        setToggledClearRows(prev => !prev);
    };

    const cargarProcesos = async (overrideParams) => {
        setShowLoading(true); // Cambia el estado a false una vez que los datos se carguen
        let copyData;
        if(overrideParams){
            // Usado tras clonar procesos: busca exactamente con el curso/año/periodo/
            // asignatura destino que se acaba de usar para clonar.
            copyData = utils.copy(overrideParams);
        }else{
            copyData = utils.copy(filters);
            const cursos = filteReference?.current?.getCursos();
            if(cursos.length>0){
                copyData.gradeId = cursos.find(c=> String(c.courseId) === String(copyData.courseId))?.gradeId;
            }
            const educationLevels = filteReference?.current?.getEducationLeves();
            if(educationLevels.length>0){
                copyData.evaluationTypeId = educationLevels.find(c=> String(c.educationLevelId) === String(copyData.educationLevelId))?.evaluationTypeId;
            }
        }
        copyData.evaluationTypeId = types.evaluationTypes.PLANILLA_PREVENTIVA;
        setParamProcesos(copyData);
        try {
            const procesosDB = await procesoService.getProcesosToNotas(copyData.courseId, copyData.schoolSubjectId, copyData.schoolYearId, copyData.periodId,types.evaluationTypes.PLANILLA_PREVENTIVA);
            if(procesosDB){
                setProcesos(procesosDB);
            }else{
                setProcesos([]);
            }
            clearRowSelection();
        } catch (error) {
          console.error("Error al obtener procesos:", error);
        }
        setShowSearch(true);
        setShowLoading(false);// Cambia el estado a false una vez que los datos se carguen
    }

    // Al clonar, el usuario pudo haber elegido un curso destino distinto al que
    // tenía la búsqueda principal. Sincroniza los filtros visibles con el primer
    // curso destino y vuelve a buscar ahí, para ver de inmediato los procesos
    // recién clonados (igual que en la clonación de logros).
    const searchAfterClone = async (destinationCourseId, schoolYearId, periodId, schoolSubjectId) => {
        try {
            const cursos = await courseService.getCursos();
            const matched = cursos.find(c => String(c.courseId) === String(destinationCourseId));
            if(matched){
                filteReference.current?.setFormValues({
                    journeyId: matched.journeyId,
                    schoolYearId,
                    periodId,
                    educationLevelId: matched.educationLevelId,
                    courseId: matched.courseId,
                    schoolSubjectId,
                });
                await cargarProcesos({ courseId: matched.courseId, gradeId: matched.gradeId, schoolYearId, periodId, schoolSubjectId });
            }else{
                console.error("No se encontró el curso destino de la clonación; se mantiene la búsqueda actual.");
                await cargarProcesos();
            }
        } catch (error) {
            console.error("Error al sincronizar los filtros tras clonar los procesos:", error);
            await cargarProcesos();
        }
    };

    const handleRowSelected = (state) => {
        setSelectedRows(state.selectedRows);
    };

    const openCloneModal = () => {
        setCloneFilters({
            journeyId: '0',
            schoolYearId: '0',
            courseIds: [],
            schoolSubjectIds: [],
            periodId: '0',
        });
        setCloneModal(true);
    };

    const closeCloneModal = () => {
        setCloneModal(false);
    };

    const handleCloneFilterChange = (newFilters) => {
        setCloneFilters(prev => ({
            ...prev,
            ...newFilters
        }));
    };

    const handleCloneSave = async () => {
        if (!cloneFilters.schoolYearId || String(cloneFilters.schoolYearId) === '0' ||
            !cloneFilters.periodId || String(cloneFilters.periodId) === '0' ||
            !cloneFilters.courseIds || cloneFilters.courseIds.length === 0 ||
            !cloneFilters.schoolSubjectIds || cloneFilters.schoolSubjectIds.length === 0) {
            Swal.fire(
                "Campos Obligatorios",
                "Por favor seleccione año escolar, periodo, uno o más cursos y una o más asignaturas de destino.",
                "error"
            );
            return;
        }

        // Se toman los nombres antes de mostrar el loading (el filtro se desmonta
        // mientras carga) para poder informar las combinaciones omitidas.
        const courseNames = new Map((cloneFilterReference.current?.getCursos() ?? []).map(c => [String(c.courseId), c.name]));
        const subjectNames = new Map((cloneFilterReference.current?.getAsignaturas() ?? []).map(s => [String(s.schoolSubjectId), s.name]));
        const describeCombination = (c) =>
            `${courseNames.get(String(c.courseId)) ?? c.courseId} - ${subjectNames.get(String(c.schoolSubjectId)) ?? c.schoolSubjectId}`;

        try {
            setCloneLoading(true);
            // Un solo request: el backend cruza cursos × asignaturas, valida cuáles
            // combinaciones tienen carga académica (docente asignado) en el año
            // escolar y crea los nuevos procesos con una única consulta masiva.
            const response = await procesoService.cloneProcesos({
                evaluationProcessIds: selectedRows.map(r => r.evaluationProcessId),
                schoolYearId: cloneFilters.schoolYearId,
                periodId: cloneFilters.periodId,
                schoolSubjectIds: cloneFilters.schoolSubjectIds,
                courseIds: cloneFilters.courseIds,
            });

            if (response && response.message === "ok") {
                const applied = response.applied ?? [];
                const skipped = response.skipped ?? [];
                const skippedHtml = skipped.length > 0
                    ? `<br/><br/>Se omitieron ${skipped.length} combinación(es) sin carga académica asignada en el año escolar:<br/>` +
                      skipped.slice(0, 15).map(describeCombination).join('<br/>') +
                      (skipped.length > 15 ? `<br/>... y ${skipped.length - 15} más` : '')
                    : '';
                Swal.fire({
                    title: "¡Felicidades!",
                    html: `Procesos clonados exitosamente en ${applied.length} combinación(es) curso/asignatura.${skippedHtml}`,
                    icon: skipped.length > 0 ? "warning" : "success"
                });
                setCloneModal(false);
                const first = applied[0];
                if (first) {
                    await searchAfterClone(first.courseId, cloneFilters.schoolYearId, cloneFilters.periodId, first.schoolSubjectId);
                } else {
                    await cargarProcesos();
                }
            } else {
                Swal.fire(
                    "Ha ocurrido un error",
                    "Por favor intente más tarde",
                    "error"
                );
            }
        } catch (error) {
            console.error("Error al clonar los procesos:", error);
            Swal.fire(
                "Ha ocurrido un error",
                error?.response?.data?.message ?? "Por favor intente más tarde",
                "error"
            );
        }
        setCloneLoading(false);
    };

    const handleInputDetailChange = (e, index, field) => {
        const element = procesos.find((_, i) => i === index);
        if(field==="percentage"){
            let numero = ((e.target.value.trim()!=="")?Number(e.target.value.trim()):0);
            numero = ((numero<0)?(numero*-1):numero);
            numero = (numero>100)?100:numero;
            element[field] =numero;
        }else{
            element[field] = e.target.value;
        }
        const newProcesses = [...procesos];
        setProcesos(newProcesses);
    };

    const columns = [
        { name: "Codigo", selector: "evaluationProcessId", grow:0.1},
        { name: "Descripción", selector: "description", grow:2, cell: (row, index) => (
            <>
            <div className="row w-100">
                <div className="col-md-10 w-100">
                        <input
                            type="text"
                            className="form-control w-100"
                            value={row.description}
                            onChange={(e) => handleInputDetailChange(e, index,'description')}/>
                </div>
            </div>
            </>), 
        },
        { name: "Porcentaje", omit:(paramProcesos.evaluationTypeId!==2),grow:1, selector: "percentage",  cell: (row, index) => (
            <>
                 <div className="row w-40">
                    <div className="col-md-4 w-40">
                            <input
                                type="number"
                                className="form-control w-40"
                                value={row.percentage}
                                onChange={(e) => handleInputDetailChange(e, index,'percentage')}/>
                    </div>
                    <div className="col-md-2 padding-top-15 w-20">
                        <h4>%</h4>
                    </div>
                </div>
            </>), 
        },
        { name: "", selector: "evaluationProcessId" ,  cell: (row, index) => (
            <i className="fas fa-xmark clear-button-searcher" aria-hidden="true" onClick={() => handleRemoveProcess(index)}></i>
        ) },
    ];

    const handleRemoveProcess = (index) => {
        const removedElement = procesos[index];
        if(removedElement.evaluationProcessId){
            Swal.fire({
                title:  '¿Está seguro de que desea eliminar este proceso?',
                text: "",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Si, eliminar!'
              }).then(async(result) => {
                if (result.isConfirmed) {
                  try{
                  
                  await procesoService.deleteProcesosAcademicoById(removedElement.evaluationProcessId);
                  Swal.fire(
                    'Felicidades!',
                    'Proceso eliminado exitosamente!',
                    'success'
                  );
                  await cargarProcesos();
                  }catch(error){
                    Swal.fire(
                        "Ha ocurrido un error",
                        "Por favor intentelo más tarde",
                        "error"
                    );
                  }
                }
              })    
        }else{
            const updatedDetails = procesos.filter((_, i) => i !== index);
            setProcesos(updatedDetails);
        }
    };

    const handleAddProcess = () => { 
        const newProcess={
            evaluationProcessId:null,
            description:"",
            percentage:((paramProcesos.evaluationTypeId===2)?0:null)
        };
        const newProcesses = [...procesos, newProcess];
        setProcesos(newProcesses);
    }

    const validateProcesos = () => {
        if(paramProcesos.evaluationTypeId === 2){
            const totalPercentage = procesos?.reduce((acc, proceso) => acc + Number(proceso.percentage), 0);
            if(totalPercentage<100){
                toast.error("Los procesos deben cubrir el 100% de asignación, estas por debajo del 100%", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
                return false;
            }
            if(totalPercentage>100){
                toast.error("Los procesos deben cubrir el 100% de asignación, estas por ancima del 100%", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
                return false;
            }
        }
        const procesosVacios = procesos.filter(p=> p.description.trim() ==="");
        if(procesosVacios.length>0){
            toast.error("La descripción de los conceptos no puede estar vacia, por favor asegurate de llenar todas las descripciones", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
              });
              return false;
        }
        return true;
    }

    const guardarProcesos = async () => { 
        const valido = validateProcesos();
        if(valido){
            setShowLoading(true); 
            let completado = true;
            for (let i = 0; (i < procesos.length && completado); i++) {
                const item = procesos[i];
                
                const itemProceso ={
                    courseId: paramProcesos.courseId,
                    gradeId:paramProcesos.gradeId,
                    schoolYearId:paramProcesos.schoolYearId,
                    periodId:paramProcesos.periodId,
                    schoolSubjectId: paramProcesos.schoolSubjectId,
                    isRecuperation:0,
                    evaluationTypeId:types.evaluationTypes.PLANILLA_PREVENTIVA
                };
                const obj = {...itemProceso, ...item};
                if(item.evaluationProcessId===null){
                  const result =  await procesoService.createProcesoAcademico(obj);
                  completado = (result?.evaluationProcessId>0);
                }else{
                 const result = await procesoService.updateProcesoAcademico(obj);
                 completado = (result?.evaluationProcessId>0);
                }
            }
            setShowLoading(false);
            if(completado){
                cargarProcesos();
                Swal.fire(
                    'Felicidades!',
                    'Proceso guardado exitosamente!',
                    'success'
                  );
            }
        }
    }

    return (
        <>
            <div className="student-table-container p-3 mb-3">
                <h1>Procesos preventivos</h1>
                <p>Esta es la vista de generación de procesos de la planilla preventiva.</p>

                <div className="row">
                    <JornadaAnioPeriodoNivelCursoAsig
                            callback={handleFilterChange}
                            ref={filteReference}
                            properties={
                                {
                                    className:'col-md-2 mb-2',
                                    id:'formPPrev',
                                    filtro:false
                                }
                            }
                        />

                    <div className="col-md-1 mb-1 margin-top-45">
                        <Button onClick={()=>{ cargarProcesos(); }} className="ml-2">Buscar</Button>
                    </div>
                    
                </div>
            </div>

                {showLoading && <Loading />}

                {showSearch && (
                   <> 
                        {!showLoading && (
                            <>
                                <div className="student-table-container p-3">
                                    <div className="col-md-4 mb-3 d-flex align-items-end margin-top-48">
                                        <button type="button" className="btn btn-primary" onClick={handleAddProcess}>
                                            Añadir Proceso
                                        </button>
                                        {canCloneProcesos && (
                                            <button
                                                type="button"
                                                className="btn-sm btn-Estudiante btn-NuevoEstudiante ms-2"
                                                onClick={openCloneModal}
                                                disabled={selectedRows.length === 0}
                                            >
                                                Clonar Procesos <i className="fa-solid fa-clone"></i>
                                            </button>
                                        )}
                                    </div>
                                    <DataTable
                                        columns={columns}
                                        data={procesos}
                                        customStyles={customStyles}
                                        className="students-datatable shadow-sm rounded table table-corporate table-bordered table-sm  my-0 dataTables_wrapper dt-bootstrap5 no-footer"
                                        noDataComponent="No hay procesos que mostrar, por favor agregalos"
                                        noHeader
                                        dense
                                        highlightOnHover
                                        pointerOnHover
                                        selectableRows={canCloneProcesos}
                                        selectableRowDisabled={(row) => !row.evaluationProcessId}
                                        onSelectedRowsChange={handleRowSelected}
                                        clearSelectedRows={toggledClearRows}
                                    />
                                   
                                    {procesos && procesos.length>0 && (
                                    <div className="col-md-12">
                                            <button type="button" className="btn btn-success center display-block" onClick={guardarProcesos}>
                                                    Guardar procesos
                                            </button>
                                    </div>
                                    )}
                                </div>
                            </>
                        )}
                    </>
                )}

            <>
            <MDBModal show={cloneModal} setShow={setCloneModal} tabIndex='-1'>
                <MDBModalDialog size='xl' fullscreen='xl-down'>
                    <MDBModalContent>
                        <MDBModalHeader>
                            <MDBModalTitle>Clonar Procesos Preventivos</MDBModalTitle>
                            <MDBBtn className='btn-close' color='none' onClick={closeCloneModal} disabled={cloneLoading}></MDBBtn>
                        </MDBModalHeader>
                        <MDBModalBody>
                            {cloneLoading && <Loading />}

                            {cloneModal && !cloneLoading && (
                                <>
                                    <p className="text-muted">
                                        Seleccione la jornada, año escolar, periodo, uno o varios cursos y una o varias asignaturas donde desea clonar los {selectedRows.length} proceso(s) seleccionados. Solo se clonará en las combinaciones curso/asignatura que tengan carga académica asignada en el año escolar.
                                    </p>
                                    <div className="row">
                                        <JornadaAnioPeriodoCursosAsigMulti
                                            callback={handleCloneFilterChange}
                                            ref={cloneFilterReference}
                                            properties={
                                                {
                                                    className:'col-md-4 mb-2',
                                                    id:'cloneProcesosFilters',
                                                    filtro:false
                                                }
                                            }
                                        />
                                    </div>
                                </>
                            )}
                        </MDBModalBody>
                        <MDBModalFooter>
                            <button type='button' className='btn-footer-close btn-primary' onClick={closeCloneModal} disabled={cloneLoading}>
                                Cerrar
                            </button>
                            <button type='button' className='btn btn-primary' onClick={handleCloneSave} disabled={cloneLoading}>
                                {cloneLoading ? 'Guardando...' : 'Guardar'}
                            </button>
                        </MDBModalFooter>
                    </MDBModalContent>
                </MDBModalDialog>
            </MDBModal>
            </>
        </>
    );
};

export default ProcesosPreventivosView;